import { EMPTY_CELL } from '@common/constants';
import { isNil, isNumber } from 'lodash';
import moment from 'moment';
import { TimeFormat } from '@common/types';

export const convertSecondsToTimeHhMm = (seconds?: number | bigint | string | null): string => {
  return !isNil(seconds) && isNumber(Number(seconds)) ? moment.unix(Number(seconds)).utc(false).format(TimeFormat.HHmmColon) : EMPTY_CELL;
};
